'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WaterPoweredIcon = function WaterPoweredIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M51 91h25v16H51zM59 16h11v74H59z'
            }),
            _react2.default.createElement('path', {
                d: 'M66.188 90h-3.376 3.376zm-6.75 0h-6.75c-.934 0-1.688.756-1.688 1.692v15.616A1.69 1.69 0 0 0 52.688 109h23.624A1.69 1.69 0 0 0 78 107.308V91.692c0-.936-.754-1.692-1.688-1.692H59.438zm10.845 1.736h5.783v15.526H52.934V91.736h17.349z',
                stroke: '#555',
                strokeWidth: '.3',
                fill: '#555'
            }),
            _react2.default.createElement('path', {
                d: 'M59.528 48.275l-.853-6.044H70.51l-.854 6.044H59.528zm10.077-12.663l.905 6.044H58.675l.905-6.044h10.025zm-.827 43.387h.57V49.067h.113c.085 0 .17-.065.227-.251l1.196-3.447c.086-.124.114-.31.114-.5v-5.2c0-.127-.028-.251-.055-.376l-1.283-3.635c-.057-.124-.141-.251-.228-.251h-.114V16.862h-.57v18.485H60.38V16.862h-.57v18.485h-.113c-.085 0-.17.06-.229.249l-1.28 3.633c-.028.126-.057.253-.057.375v5.139c0 .127.03.25.057.378l1.28 3.633c.059.124.144.248.229.248h.114v29.87h.57V49.068h8.398v29.932z',
                fill: '#555'
            }),
            _react2.default.createElement('path', {
                d: 'M68.572 47.41l.879-4.314h-9.758l.704 4.313h8.175zm-10.916-6.044H71.57l-1.584 7.774h-11.06l-1.27-7.774zm2.802-4.889l-.754 4.313h9.755l-.846-4.313h-8.155zm11.104 6.044H57.645l1.359-7.774h11.034l1.524 7.774zm-1.35 48.344h-2.3V49.932h-6.668v40.806h-2.3V49.537c-.108-.13-.2-.296-.293-.496l-1.28-3.633a4.133 4.133 0 0 1-.076-.33 1.944 1.944 0 0 1-.03-.335v-5.139c0-.18.019-.298.072-.54l1.304-3.725c.065-.21.167-.394.303-.538V15.996h2.3v18.486h6.64V15.996h2.3V34.87c.11.13.202.299.293.5l1.282 3.635c.084.348.104.473.104.664v5.2c0 .323-.05.611-.191.87l-1.156 3.33c-.065.21-.166.397-.303.542v41.254zm-1.73-.866V48.201h.98c-.336 0-.537.19-.586.315l1.23-3.543.067-.098c-.043.063-.04.049-.04-.005v-5.201a.831.831 0 0 0-.024-.138l-1.146-3.259h-.51l-8.757-.06c.327 0 .533-.189.582-.313l-1.257 3.567c-.02.094-.026.128-.026.138v5.139c.01.066.014.088.026.14l1.142 3.254h.512l8.968.064V90h-1.161zm-8.463-41.798c.092.043.16.102.215.167.018.02.019.022.016.016l-.064-.183h-.167zm.264-12.318a.2.2 0 0 1-.005.016l.005-.016zm8.836.33a.615.615 0 0 1-.228-.175c-.018-.021-.02-.024-.017-.019l.068.194h.177zm-.248 12.32a.208.208 0 0 1 .005-.017l-.005.016zm-.093 41.466v-.865h.57v.865h-.57z',
                fill: '#555',
                fillRule: 'nonzero'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                d: 'M57 99.31h2.31V97H57zM63 99.31h2.31V97H63zM69 99.31h2.31V97H69z'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                fillRule: 'nonzero',
                d: 'M87.144 53.754v-2.307h16.696v57.816H26.625V51.447h16.23v2.307H28.932v53.202h72.6V53.754z'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                fillRule: 'nonzero',
                d: 'M108.157 47.333H87.081v-2.308h23.384v70.657H20V45.025h22.835v2.308H22.309v66.042h85.848z'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                fillRule: 'nonzero',
                d: 'M84.395 58.351v2.1H28.3v-2.1zM102.163 58.351v2.1h-5.578v-2.1zM93.348 58.351v2.1H87.77v-2.1z'
            })
        )
    );
};

WaterPoweredIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg'
};

var WaterPowered = function (_React$Component) {
    _inherits(WaterPowered, _React$Component);

    function WaterPowered() {
        _classCallCheck(this, WaterPowered);

        return _possibleConstructorReturn(this, (WaterPowered.__proto__ || Object.getPrototypeOf(WaterPowered)).apply(this, arguments));
    }

    _createClass(WaterPowered, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(WaterPoweredIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return WaterPowered;
}(_react2.default.Component);

exports.default = WaterPowered;